import React from 'react'
import iconNames from 'theme/icons'
import {t} from "helpers/language"

export const skill = {
  key: "HOME_COMPANY",
  group: 'contacts',
  label: t("Set up your company"),
  desc: t("Set up your company's address, contact details and add your colleagues"),
  location: '/contacts/manage',
  steps: [
    {
      target: '.companyTabs-home',
      content: <div>This is your home company. Here you can manage your own company details. <i>Click the Home button</i> to view your company</div>,
    },
    {
      target: '.companyHeader-address',
      content: <div>Your company address is shown here. To change it <i>Click on the address</i></div>,
    },
    {
      target: '.editableValue-edit-menu',
      content: <div>Click <i>Edit This Address</i> to change or review it</div>,
      awaitElement: {awaitTransition: 400},
    },
    {
      // Inline tooltip in location form
      dummy: true,
      editAddress: true,  // sets the page number on the location form
    },
    {
      firstTimeOnly: true,
      title: "Your Address Saved",
      titleIcon: iconNames.tick,
      titleIconColor: "green",
      content: "Now you've set up your company address, let's continue by adding your first contact",
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Add a contact",
          primary: true,
          type: 'skill',
          skill: "ADD_CONTACT",
        },
      ],
    },
  ],
}

export default skill
